import type { RecordPanelWidthPersistenceService } from '../../application'

import { BaseWebStorage } from './Base'
import type { SerializedRecordPanelWidth } from './RecordPanelWidthTypes'
import { isSerializedRecordPanelWidth } from './Validators'

export class WebStorageRecordPanelWidthPersistenceService extends BaseWebStorage<number | null, SerializedRecordPanelWidth>
    implements RecordPanelWidthPersistenceService
{
    protected readonly fallbackValue = null

    protected readonly key = 'cwRecordPanelWidth'

    /** A width is a width in any version */
    protected override readonly ignoreVersionMismatch = true

    protected toSerializable (width: number | null): SerializedRecordPanelWidth {
        return width
    }

    protected isValidSerializable (unknownValue: unknown): unknownValue is SerializedRecordPanelWidth {
        return isSerializedRecordPanelWidth(unknownValue)
    }

    protected fromSerializable (width: SerializedRecordPanelWidth): number | null {
        return width
    }

    retrieve (): number | null {
        return this.retrieveDeserialize()
    }

    /** `null` and widths JSON can't write (NaN and Infinity) drop the saved width */
    persist (width: number | null): void {
        if (width !== null && Number.isFinite(width)) {
            this.persistSerialize(Math.round(width))
        } else {
            this.remove()
        }
    }
}
